import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { getOperationalOverview } from 'features/operationalManagement/operationalManagementSlice'
import { MetricCard } from 'components/ui/MetricCard/MetricCard'
import { tokens } from 'styling/tokens'
import { AlertsPanel } from '../components/AlertsPanel'
import { KpiGrid } from '../Organogram.styled'
import { TeamsIcon } from '../icons'

const AssignedIcon = (
  <svg width='18' height='18' viewBox='0 0 20 20' fill='none'>
    <path
      d='M10 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-6 7c0-2.5 2.7-4.5 6-4.5 1 0 1.95.18 2.8.5l-.75.75-1.8-.5a5.8 5.8 0 0 0-.25-.02C7.4 13.23 5.5 14.7 5.5 16.5V17H4v-.5ZM17.5 13l-4 4-2-2 1-1 1 1 3-3 1 1Z'
      fill='currentColor'
    />
  </svg>
)

const UnassignedIcon = (
  <svg width='18' height='18' viewBox='0 0 20 20' fill='none'>
    <path
      d='M10 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-6 7c0-2.5 2.7-4.5 6-4.5.6 0 1.17.07 1.7.2l-.95.95A6.5 6.5 0 0 0 10 13.5C7.4 13.5 5.5 14.7 5.5 16.5V17H4v-.5Zm10.29-4.29 1.5 1.5-1.5 1.5 1.06 1.06 1.5-1.5 1.5 1.5 1.06-1.06-1.5-1.5 1.5-1.5-1.06-1.06-1.5 1.5-1.5-1.5-1.06 1.06Z'
      fill='currentColor'
    />
  </svg>
)

const WarningIcon = (
  <svg width='18' height='18' viewBox='0 0 20 20' fill='none'>
    <path
      d='M10 2 1.5 17h17L10 2Zm0 3.25 6.42 11.25H3.58L10 5.25ZM9.25 9v3.5h1.5V9h-1.5Zm0 4.5V15h1.5v-1.5h-1.5Z'
      fill='currentColor'
    />
  </svg>
)

export const OverviewTab = () => {
  const dispatch = useDispatch<AppDispatch>()
  const { overview } = useSelector((state: RootState) => state.operationalManagement)

  useEffect(() => {
    if (overview == null) {
      dispatch(getOperationalOverview())
    }
  }, [dispatch, overview])

  return (
    <>
      <KpiGrid>
        <MetricCard
          layout='inline'
          icon={<TeamsIcon />}
          value={overview?.totalTeamCount ?? 0}
          label='Total Teams'
          accentColor={tokens.status.info.fg}
        />
        <MetricCard
          layout='inline'
          icon={AssignedIcon}
          value={overview?.totalAssignedUserCount ?? 0}
          label='Assigned'
          accentColor={tokens.status.success.fg}
        />
        <MetricCard
          layout='inline'
          icon={UnassignedIcon}
          value={overview?.totalUnassignedUserCount ?? 0}
          label='Unassigned'
          accentColor={tokens.status.danger.fg}
        />
        <MetricCard
          layout='inline'
          icon={WarningIcon}
          value={overview?.teamWithoutSupervisorCount ?? 0}
          label='Missing Supervisor'
          accentColor={tokens.status.warning.fg}
        />
      </KpiGrid>

      <AlertsPanel overview={overview} />
    </>
  )
}
